import { FC } from 'react';
import { useTheme } from '../../themeContext';
import TableContainer from '@mui/material/TableContainer';
import { TableCell } from '@mui/material';
// eslint-disable-next-line
const CustomTableCellHOC = (WrappedComponent: any): FC<any> => {
  // eslint-disable-next-line
  const ThemedComponent: FC<any> = (props) => {
    const theme = useTheme(); // ✅ Correct hook usage inside component

    const sx = {
      backgroundColor: theme === 'dark' ? (props.isNew ? '#3a3a3a' : '#2c2c2c') : props.isNew ? '#f5f5f5' : '#fff',
      color: theme === 'dark' ? (props.isNew ? '#ffffff' : '#eee') : props.isNew ? '#000000' : '#000',
      fontSize: '1rem',
    };

    return <WrappedComponent {...props} sx={sx} />;
  };

  return ThemedComponent;
};

export const CustomTableCell = CustomTableCellHOC(TableCell);

// eslint-disable-next-line
const CustomTableContainerHOC = (WrappedComponent: any): FC<any> => {
  // eslint-disable-next-line
  const ThemedComponent: FC<any> = (props) => {
    const theme = useTheme();

    const sx = {
      maxHeight: '100%',
      overflowY: 'auto',
      background: theme === 'dark' ? 'linear-gradient(135deg, #1c1c1c, #2c2c2c)' : 'linear-gradient(135deg, #ffffff, #f0f0f0)',
      boxShadow:
        theme === 'dark'
          ? '5px 5px 15px rgba(0,0,0,0.6), -5px -5px 15px rgba(255,255,255,0.05)'
          : '5px 5px 15px rgba(0,0,0,0.2), -5px -5px 15px rgba(255,255,255,0.6)',
      borderRadius: '15px',
    };

    return <WrappedComponent {...props} sx={sx} />;
  };

  return ThemedComponent;
};

export const CustomTableContainer = CustomTableContainerHOC(TableContainer);
